/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `file_capabilities` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class FileCapabilitiesMesg : Mesg {
    public constructor() : super("FileCapabilities", Profile.MesgNum.FILE_CAPABILITIES)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** type. */
    public var type: File?
        get() = (getFieldValue(TYPE_FIELD_NUM) as? UByte)?.let { File.fromValue(it) }
        set(value) = setFieldValue(TYPE_FIELD_NUM, value?.value)

    /** flags. */
    public var flags: FileFlags?
        get() = (getFieldValue(FLAGS_FIELD_NUM) as? UByte)?.let { FileFlags.fromValue(it) }
        set(value) = setFieldValue(FLAGS_FIELD_NUM, value?.value)

    /** directory. */
    public var directory: String?
        get() = getFieldValue(DIRECTORY_FIELD_NUM) as? String
        set(value) = setFieldValue(DIRECTORY_FIELD_NUM, value)

    /** max_count. */
    public var maxCount: UShort?
        get() = getFieldValue(MAX_COUNT_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MAX_COUNT_FIELD_NUM, value)

    /** max_size, in bytes. */
    public var maxSize: UInt?
        get() = getFieldValue(MAX_SIZE_FIELD_NUM) as? UInt
        set(value) = setFieldValue(MAX_SIZE_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val TYPE_FIELD_NUM: UByte = 0u
        public const val FLAGS_FIELD_NUM: UByte = 1u
        public const val DIRECTORY_FIELD_NUM: UByte = 2u
        public const val MAX_COUNT_FIELD_NUM: UByte = 3u
        public const val MAX_SIZE_FIELD_NUM: UByte = 4u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("Type", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("Flags", 1u, BaseType.UINT8Z, 1.0, 0.0, "", false)
            fields[2] = Field("Directory", 2u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[3] = Field("MaxCount", 3u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[4] = Field("MaxSize", 4u, BaseType.UINT32, 1.0, 0.0, "bytes", false)
            return fields
        }
    }
}
